
import { Box } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { formatDateString } from 'utils/formatDayjsDateTime'
import { DensityStyleTypes } from '../../../../types'

interface RenderDateProps {
  // date: string
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  // navigate: (route: string) => void
}

const RenderDateCell: React.FC<RenderDateProps> = ({ params, densityStyles: _densityStyles }) => {
  const dateValue = typeof params?.value === 'object' ? formatDateString(params?.value) : params?.value
  return (
    <Box
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flexGrow: 1,
        px: 0.3,
      }}
    >
      {dateValue ? dateValue : null}
    </Box>
  )
}
export default RenderDateCell
